import React from 'react';
import { Select, SelectProps } from 'antd';
import { noop } from 'lodash';
import { useQuery } from 'react-query';
import {
  getUserBranchListByMgid,
  GetUserBranchListByMgidParams,
  MgBUserResponse,
} from 'services/parametersService';

export type ParListSelectUserSalesProps = SelectProps<any> & {
  value?: any;
  params: GetUserBranchListByMgidParams;
  onChange?: (Usersales: MgBUserResponse) => void;
  onSelected?: (Usersales: MgBUserResponse) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
};

const ParListSelectUserSales = ({
  value,
  params,
  onChange = noop,
  onSelected,
  ...otherProps
}: ParListSelectUserSalesProps) => {
  const { data: Usersales, isLoading } = useQuery(
    ['getUserBranchListByMgid', params],
    () =>
      getUserBranchListByMgid(params).then((res) => {
        return res.list || [];
      }),
    { enabled: !isNaN(params.brid) && !isNaN(params.mgid) }
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      if (value.brid)
        onSelected(
          Usersales?.find((item) => item.mguserid === value.mguserid)!
        );
      else onSelected(Usersales?.find((item) => item.mguserid === value)!);
    }
  };

  return (
    <Select
      onChange={handleChange}
      {...otherProps}
      loading={isLoading}
      allowClear
      value={!value?.mguserid ? value : value.mguserid}
    >
      {Usersales?.map((user) => (
        <Select.Option value={user.mguserid} key={user.mguserid}>
          {user.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ParListSelectUserSales;
